/* eslint-disable no-unused-vars */
import styled from 'styled-components/native';
import { Button, TextInput, Switch } from 'react-native-paper';
import { colors } from '../../infrastructure/theme/colors';
import SelectDropdown from 'react-native-select-dropdown';
import { Picker } from 'react-native';
import { useMediaQuery } from 'react-responsive';
import { Dimensions } from 'react-native';

const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

export const styledPicker = styled(Picker)`
  padding: 20px;
  background-color: #ebebeb;
  border: 0;
`;

export const FormContainer = styled.View`
  background-color: rgba(255, 255, 255, 0.7);
  padding: ${(props) => props.theme.space[4]};
  width: 100%;
  height: 100%;
  display: flex;
`;

export const FormVeil = styled.View`
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.3);
`;

export const FormButton = styled(Button).attrs({})`
  background-color: #7dcdc5;
  align-self: center;

  padding: ${(props) => props.theme.space[2]};
  margin-bottom: 5px;
  margin-top: 15px;
  width: 100%;
  text-align: center;
  position: relative;
  // bottom: 10%;
`;

//
export const FormSwitch = styled(Switch)``;

export const FormInput = styled(TextInput)`
  width: 100%;
`;

export const FormCenter = styled.View`
  position: relative;
  display: flex;
  width: 100%;
`;

export const InputFormCenter = styled.View`
  margin: 0;
`;

export const MobileFormCenter = styled.View`
  margin: 0;
`;
